/**
 * @flow
 * @format
 */

import { get } from 'lodash';

import { constants } from '~/actions/modal';
import type { ModalState, ModalActions } from '~/actions/modal';

import designRoutines from '~/routines/design';

type StateType = ModalState;
export const initialState: StateType = {
  modalType: null,
  modalProps: {},
};

export default function(
  state: StateType = initialState,
  action: ModalActions,
): StateType {
  switch (action.type) {
    case constants.SHOW_MODAL:
      return {
        modalType: get(action.data, 'modalType'),
        modalProps: get(action.data, 'modalProps'),
      };
    case constants.HIDE_MODAL:
    case designRoutines.saveDesignRecord.SUCCESS:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modal.js